<template>
  <q-form ref="formRef" greedy>
    <div class="text-h5 text-bold">テキスト</div>
    <div class="text-subtitle2">テキストのスタイル・アクション設定</div>
    <div class="row q-mt-md">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>タイプ<span class="text-brand-red">*</span></div>
        <div class="text-caption">Type</div>
      </div>
      <q-select
        outlined
        dense
        emit-value
        map-options
        v-model="value.type"
        :options="typeList"
        class="col"
        disable
      >
        <template v-slot:selected-item="scope">
          <div class="column">
            <div>{{ scope.opt.label }}</div>
            <div class="text-caption">{{ scope.opt.value }}</div>
          </div>
        </template>
      </q-select>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>テキスト</div>
        <div class="text-caption">Text</div>
      </div>
      <InputEmojiSelector
        v-model="value.text"
        :rules="[(val) => (val && val.length > 0) || 'invalid property']"
        type="textarea"
        :placeholder="'Text'"
        class="col"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>フレックス</div>
        <div class="text-caption">Flex</div>
      </div>
      <q-input
        outlined
        dense
        type="number"
        min="0"
        v-model.number="value.flex"
        placholder="Num."
        class="col"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>マージン</div>
        <div class="text-caption">margin</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.margin"
        :rules="[
          (val) => marginValidate(val) || 'invalid property',
        ]"
        placeholder="XXpx"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-btn-dropdown
            no-caps
            unelevated
            color="brand-grey"
            label="px or keywords"
          >
            <q-list>
              <q-item
                v-for="(item, index) in marginList"
                clickable
                v-close-popup
                :key="index"
                @click="value.margin = item"
              >
                <q-item-section>
                  <q-item-label>{{ item }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>サイズ</div>
        <div class="text-caption">size</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.size"
        :rules="[
          (val) => sizeValidate(val) || 'invalid property',
        ]"
        placeholder="XXpx"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-btn-dropdown
            no-caps
            unelevated
            color="brand-grey"
            label="px or keywords"
          >
            <q-list>
              <q-item
                v-for="(item, index) in sizeList"
                clickable
                v-close-popup
                :key="index"
                @click="value.size = item"
              >
                <q-item-section>
                  <q-item-label>{{ item }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>行間</div>
        <div class="text-caption">lineSpacing</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.lineSpacing"
        :rules="[
          (val) => pxValidate(val) || 'invalid property',
        ]"
        placeholder="XXpx"
        class="col"
      />
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>カラー</div>
        <div class="text-caption">color</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.color"
        :rules="[
          (val) => colorValidate(val) || 'invalid property',
        ]"
        placeholder="#FFFFFF"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-icon name="colorize" class="cursor-pointer">
            <q-popup-proxy cover transition-show="scale" transition-hide="scale">
              <q-color no-header no-footer v-model="value.color" />
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>太さ</div>
        <div class="text-caption">weight</div>
      </div>
      <q-select
        outlined
        dense
        v-model="value.weight"
        :options="['', 'regular', 'bold']"
        class="col"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>スタイル</div>
        <div class="text-caption">style</div>
      </div>
      <q-select
        outlined
        dense
        v-model="value.style"
        :options="['', 'normal', 'italic']"
        class="col"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>文字装飾</div>
        <div class="text-caption">decoration</div>
      </div>
      <q-select
        outlined
        dense
        v-model="value.decoration"
        :options="['', 'none', 'underline', 'line-through']"
        class="col"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>ポジション</div>
        <div class="text-caption">position</div>
      </div>
      <q-select
        outlined
        dense
        v-model="value.position"
        :options="['', 'relative', 'absolute']"
        class="col"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>行揃え</div>
        <div class="text-caption">align</div>
      </div>
      <q-select
        outlined
        dense
        v-model="value.align"
        :options="['', 'start', 'end', 'center']"
        class="col"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>垂直位置</div>
        <div class="text-caption">gravity</div>
      </div>
      <q-select
        outlined
        dense
        v-model="value.gravity"
        :options="['', 'top', 'bottom', 'center']"
        class="col"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>折り返し</div>
        <div class="text-caption">wrap</div>
      </div>
      <q-select
        outlined
        dense
        emit-value
        map-options
        v-model="value.wrap"
        :options="trueFalseList"
        class="col"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>フォント拡縮</div>
        <div class="text-caption">scaling</div>
      </div>
      <q-select
        outlined
        dense
        emit-value
        map-options
        v-model="value.scaling"
        :options="trueFalseList"
        class="col"
      />
    </div>
    <div class="row q-mt-sm" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>最大行数</div>
        <div class="text-caption">maxLines</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.maxLines"
        class="col"
        hint="`maxLines` is not supported in simulator"
      />
    </div>
    <div class="row q-mt-lg" v-if="isAdmin">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>フォント調整</div>
        <div class="text-caption">adjustMode</div>
      </div>
      <q-select
        outlined
        dense
        v-model="value.adjustMode"
        :options="['', 'shrink-to-fit']"
        class="col"
        hint="`adjustMode` is not supported in simulator"
      />
    </div>
    <q-separator class="q-mt-lg q-mb-md" v-if="isAdmin" />
    <Offset v-model="value" v-if="isAdmin" />
    <q-separator class="q-my-md" v-if="isAdmin" />
    <Action v-model="value.action" :isAdmin="isAdmin" v-if="isAdmin" />
  </q-form>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageText, IFlexMessageURIAction } from '@/utils/types'
import Action from '@/components/common/flex-message/forms/Action.vue'
import Offset from '@/components/common/flex-message/forms/Offset.vue'
import InputEmojiSelector from '@/components/common/ui/InputEmojiSelector.vue'

@Options({
  components: { InputEmojiSelector, Offset, Action },
  directives: { maska },
  emits: ['update:modelValue', 'update:validateValue'],
})
export default class Text extends Vue {
  @Prop()
  modelValue!: IFlexMessageText

  @Prop()
  isAdmin!: boolean

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageText) {
    this.$emit('update:modelValue', value)
  }

  get typeList() {
    return [
      {
        label: 'テキスト',
        value: 'text',
      },
    ]
  }

  get marginList() {
    return ['none', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']
  }

  get sizeList() {
    return ['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl', '3xl', '4xl', '5xl']
  }

  get trueFalseList() {
    return [
      {
        label: '',
        value: '',
      },
      {
        label: 'True',
        value: true,
      },
      {
        label: 'False',
        value: false,
      },
    ]
  }

  colorValidate(val) {
    if (!val) return true
    return /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/.test(val)
  }

  marginValidate(val) {
    if (!val) return true

    const isPx = /^\d+(\.\d+)?px$/.test(val)
    const isKeyword = this.marginList.includes(val)
    return !(!isPx && !isKeyword)
  }

  sizeValidate(val) {
    if (!val) return true

    const isPx = /^\d+(\.\d+)?px$/.test(val)
    const isKeyword = this.sizeList.includes(val)
    return !(!isPx && !isKeyword)
  }

  pxValidate(val) {
    if (!val) return true
    return /^(\d+(\.\d+)?)(px)$/.test(val)
  }

  @Watch('value', { deep: true })
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    if (this.value.action) {
      if (this.value.action.type === 'uri') {
        const uriAction: IFlexMessageURIAction = {
          type: 'uri',
          label: 'action',
          uri: 'http://linecorp.com/',
          altUri: {
            desktop: '',
          },
        }
        this.value.action = { ...uriAction, ...this.value.action }
      }
    }
    this.validate()
  }
}
</script>

<style scoped lang="scss">

</style>
